<template>
  <el-dialog title="上传视频" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div style="height: 300px;">
                <el-upload style="position: relative;" :action="api.uploadFileUrl" :headers="headers" accept=".mp4"
                          :on-preview="handlePictureCardPreview2" :on-success="uploadPictureSuccess"
                          :show-file-list="true" :on-remove="handleRemoveVideo" :on-change="uploadPictureChange" :on-progress="upVideo"
                          list-type="picture-card" class="videoUpload">
                          <video v-if="formData.vedioUrl" width="100%" controls="controls" :src="formData.vedioUrl"
                            class="avatar2"></video>
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import store from "@/store";

import api from "@/api/projectApi";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'excludeId', 'siteFloorLevel', 'orgId','companyId','isWithoutEnd'],
  mixins: [selectDialogMixins],

  computed: {

    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    this.initSetting();
    if (this.excludeId) {
      console.log("this.excludeId",this.excludeId)
      this.formData.excludeId = [this.excludeId]
      console.log("this.formData.excludeId",this.formData.excludeId)
    }
    if (this.siteFloorLevel) {
      this.formData.siteFloorLevel = this.siteFloorLevel
    }
    if (this.orgId) {
      this.formData.orgId = this.orgId
    }
    if (this.orgIdPath) {
      this.formData.orgIdPath = this.orgIdPath
    }
    if (this.companyId){
      this.formData.companyId = this.companyId
    }
    if (this.isWithoutEnd){
      this.formData.isWithoutEnd = this.isWithoutEnd
    }

    if (this.param) {
      if (this.param.orgIdPath) {
        this.formData.orgIdPath = this.param.orgIdPath
      }
      if (this.param.parentSiteId) {
        this.formData.parentSiteId = this.param.parentSiteId
      }
      if (this.param.siteFloorLevel) {
        this.formData.siteFloorLevel = this.param.siteFloorLevel
      }
    }
  },


  data() {
    return {
      total: 0,
      filterText: '',
      data: [],

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        vedioUrl:'',
        vedioName:""
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      searchSiteAccount: null,
      selectedRow: {
        id: '', name: '', orgId: null, orgIdPath: null
      }
    };
  },


  methods: {
    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList,"151");
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    upVideo(){
      this.$mask.open()

    },
    handlePictureCardPreview2(file) {
      console.log(file, file.url, "99999")
      this.formData.vedioUrl = file.url;
      this.dialogVisible = true;
    },
    uploadPictureSuccess(res, file) {

      var _this = this
      if (file.status == "success") {
        _this.$message({
          message: '视频上传成功',
          type: 'success'
        })
     
        this.$mask.close()

        console.log(res, '上传成功后的res视频');
        this.formData.vedioUrl = res.data.url

      }
      // this.form.url = res.msg
      // this.formData.vedioUrl = file.url;
      // console.log( file.url," file.url的值");
      this.isShow = true

    },
    uploadPictureChange(file, fileList) {
     

      console.log(file, fileList,"153")
      this.formData.vedioName = file.name
      let _this = this
      this.hideUpload = fileList.length >= this.limitCount;
      var audioElement = new Audio(file.url), duration;
      audioElement.addEventListener("loadedmetadata", function () {
        // _this.form.time = audioElement.duration;
        // console.log('时长：' + _this.form.time + 's')
      })
    

    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },


    radioChangeEvent ({ row }) {
      this.selectedRow = {
        id: row.id,
        name: row.userName,
        orgId: row.snSiteInfoDTO.orgId,
        orgIdPath: row.snSiteInfoDTO.orgIdPath,
        orgName: row.snSiteInfoDTO.orgName,
        siteMan: row.snSiteInfoDTO.siteMan,
        siteManMobile: row.snSiteInfoDTO.siteManMobile
      }
    },


    commitRow() {
      if (this.formData.vedioUrl !== '') {
        this.$emit('commitVideo', this.formData)
        this.dialogClose()
      } else {
        this.$message.warning('请先上传视频')
      }
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },







    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },



    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.snUser.getPageDataUrl,
        param: this.formData,
        method: 'post',
        columns: [
          { type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
          { title: '网点账号', field: 'userAccount', width: 140, },
          { title: '网点名称', field: 'userName', width: 140, },
          { title: '简称', field: 'userShortName', width: 110, },
          { title: '服务中心', field: 'snSiteInfoDTO.orgName', width: 140 },
          { title: '联系方式', field: 'userMobile', width: 110, },
          { title: '地址', field: 'area', width: 280,
            slots: {
              default: ({ row }) => {
                return [
                  <div><span>{row.userProvince}{row.userCity}{row.userCounty}{row.userTown}</span></div>
                ]
              }
            }
          },
          { field: 'stat', title: '状态', width: 150, slots: {
              default: ({row}) => {
                if (row.stat == 1) {
                  return [
                    <div class="txt-status disable">
                      <span>待审核</span>
                    </div>
                  ];
                } else if (row.stat == 2) {
                  return [
                    <div class="txt-status disable">
                      <span>审核中</span>
                    </div>
                  ];
                } else if (row.stat == 3) {
                  return [
                    <div class="txt-status disable">
                      <span>审核驳回</span>
                    </div>
                  ];
                } else if (row.stat == 5) {
                  return [
                    <div class="txt-status ">
                      <span>已审核</span>
                    </div>
                  ];
                } else if (row.stat == 91) {
                  return [
                    <div class="txt-status disable">
                      <span>暂停</span>
                    </div>
                  ];
                } else if (row.stat == 92) {
                  return [
                    <div class="txt-status disable">
                      <span>暂挂</span>
                    </div>
                  ];
                } else if (row.stat == 98) {
                  return [
                    <div class="txt-status disable">
                      <span>撤消</span>
                    </div>
                  ];
                } else if (row.stat == 99) {
                  return [
                    <div class="txt-status disable">
                      <span>黑名单</span>
                    </div>
                  ];
                }
              }
            }
          },
          { field: 'createTime', title: '创建时间', width: 110 },
          { title: '创建人', field: 'createBy', width: 110, },
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep .el-upload--picture-card {
  margin:20px 10px;
  width: 70px;
  height: 70px;
  line-height: 70px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  // display:none;
  width: 0px;
  height: 0px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
::v-deep .avatar2 {
  position: absolute;
  width: 130px;
  height: 70px;
  top: 40px;
  left: 100px;
}

// ::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
//   display: none !important;
// }
</style>
